var forms = (function () {
function showReloadButton() {
    if (document.getElementsByClassName("Form__Success__Message").length > 0) { 
        // Show reload button button
        var button = document.getElementById("ReloadBtn");
        if (button) {
            button.classList.remove("d-none");

            button.onclick = function(){
                reloadPage();
            }
        }
    }
}

function reloadPage() {
    location.replace(location.href); 
}

return {
    showReloadButton: showReloadButton,
  };
})();

export default forms;
